export async function runAsyncOperation<T>(
  element: HTMLElement,
  promiseFn: () => Promise<T>,
  options?: { appendToElement?: boolean }
): Promise<T> {
  element.classList.add("relative");

  const overlay = document.createElement("div");
  overlay.classList.add(
    "absolute",
    "bg-slate-400/25",
    "flex",
    "items-center",
    "justify-center",
    "rounded-md"
  );

  if (!options?.appendToElement) {
    overlay.classList.add("-m-2", "z-[2000]");
  }

  const formRect = element.getBoundingClientRect();

  overlay.style.left = options?.appendToElement ? "0px" : `${formRect.x}px`;
  overlay.style.top = options?.appendToElement ? "0px" : `${formRect.y}px`;
  overlay.style.width = options?.appendToElement
    ? "0px"
    : `${formRect.width + 16}px`;
  overlay.style.height = options?.appendToElement
    ? "0px"
    : `${formRect.height + 16}px`;

  overlay.innerHTML = `
            <sl-spinner
          style="
            font-size: 3rem;
            --indicator-color: #475669;
            --track-color: #f1f5f9;
          "
        ></sl-spinner>`;

  if (options?.appendToElement) {
    element.append(overlay);
  } else {
    document.body.appendChild(overlay);
  }

  try {
    return await promiseFn();
  } catch (ex: any) {
    throw ex;
  } finally {
    overlay.remove();
  }
}

export function executeAsync(fn: () => void): void {
  setTimeout(() => {
    fn();
  }, 0);
}
